/**
 * Admin Layout Component
 *
 * Shared layout wrapper for all admin pages.
 * Includes navigation, page structure, and footer.
 */

import React from 'react';
import AdminNav from './AdminNav';
import Footer from '../Footer';

const AdminLayout = ({ children, title }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <AdminNav />

      <div className="flex-grow py-10">
        <header className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {title && (
            <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
          )}
        </header>

        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
          {children}
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default AdminLayout;
